<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="za-gua show-book">
      <h5>【雜卦】</h5>
      <p>
        乾剛，坤柔。比樂，師憂。臨、觀之義，或與或求。
        屯，見而不失其居。蒙，雜而著。 震，起也。艮，止也。損、益，盛衰之始也。
      </p>
      <p>大畜，時也。无妄，災也。萃聚，而升不來也。謙輕，而豫怠也。</p>
      <p>
        噬嗑，食也。賁，无色也。兌見，而巽伏也。隨，无故也。蠱，則飭也。
        剝，爛也。復，反也。晉，晝也。明夷，誅也。井通，而困相遇也。
      </p>
      <p>
        咸，速也。恒，久也。
        渙，離也。節，止也。解，緩也。蹇，難也。睽，外也。家人，內也。
        否、泰，反其類也。大壯，則止。遯，則退也。大有，眾也。同人，親也。
        革，去故也。鼎，取新也。小過，過也。中孚，信也。豐，多故也。親寡，旅也。
        離上，而坎下也。小畜，寡也。履，不處也。需，不進也。訟，不親也。
        大過，顛也。姤，遇也，柔遇剛也。
        漸，女歸待男行也。頤，養正也。既濟，定也。
        歸妹，女之終也。未濟，男之窮也。
        夬，決也，剛決柔也。君子道長，小人道憂也。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="za-gua show-book">
      <h5>【杂卦】</h5>
      <p>
        乾刚，坤柔。比乐，师忧。临、观之义，或与或求。
        屯，见而不失其居。蒙，杂而著。 震，起也。艮，止也。损、益，盛衰之始也。
      </p>
      <p>大畜，时也。无妄，灾也。萃聚，而升不来也。谦轻，而豫怠也。</p>
      <p>
        噬嗑，食也。贲，无色也。兑见，而巽伏也。随，无故也。蛊，则饬也。
        剥，烂也。复，反也。晋，昼也。明夷，诛也。井通，而困相遇也。
      </p>
      <p>
        咸，速也。恒，久也。
        涣，离也。节，止也。解，缓也。蹇，难也。睽，外也。家人，内也。
        否、泰，反其类也。大壮，则止。遯，则退也。大有，众也。同人，亲也。
        革，去故也。鼎，取新也。小过，过也。中孚，信也。丰，多故也。亲寡，旅也。
        离上，而坎下也。小畜，寡也。履，不处也。需，不进也。讼，不亲也。
        大过，颠也。姤，遇也，柔遇刚也。
        渐，女归待男行也。颐，养正也。既济，定也。
        归妹，女之终也。未济，男之穷也。
        夬，决也，刚决柔也。君子道长，小人道忧也。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
